import {useEffect} from 'react';
import {redirectToLandingLogin} from '../utils/greeting';

/** Редирект на страницу входа лендинга (app /login отключён) */
export default function LandingLoginRedirect() {
    useEffect(() => {
        redirectToLandingLogin();
    }, []);

    return null;
}
